module.exports = __webpack_public_path__ + "img/angle.93471c37.svg";